module.exports = __webpack_public_path__ + "ug.svg?f6dbcb210c928f287afbbbf2a191c724";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/ug.svg
// module id = 1670
// module chunks = 0